import logger from './logger';
import { STORAGE_THEME_MODE, THEME_MODES } from './constants';
/**
 * 门户主题偏好持久化（与 Electron 客户端 themeMode 语义一致）。
 * 生效主题由 jitsi-meet 的 JitsiThemeProvider 写入 <html data-theme>，
 * SCSS 通过 [data-theme='dark'/'light'] 选择配色。
 */
/**
 * 读取用户主题偏好。
 *
 * @returns {ThemeMode} themeMode（默认跟随系统）。
 */
export function getThemeMode() {
    try {
        const stored = localStorage.getItem(STORAGE_THEME_MODE);
        if (stored === THEME_MODES.LIGHT
            || stored === THEME_MODES.DARK
            || stored === THEME_MODES.SYSTEM) {
            return stored;
        }
    }
    catch (e) {
        logger.warn(`读取主题偏好失败 | ${e?.message}`);
    }
    return THEME_MODES.SYSTEM;
}
/**
 * 保存主题偏好。
 *
 * @param {ThemeMode} mode - light / dark / system。
 * @returns {void}
 */
export function saveThemeMode(mode) {
    try {
        localStorage.setItem(STORAGE_THEME_MODE, mode);
        logger.info(`已保存主题偏好 | themeMode=${mode}`);
    }
    catch (e) {
        logger.warn(`保存主题偏好失败 | ${e?.message}`);
    }
}
